var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_invitation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_invitation"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.2929814 C11.3601562,18.2929814 10.715625,18.1328257 10.16875,17.7023584 L2,11.8008159 L2,20.1250064 C2,21.1601591 2.83984375,22 3.875,22 L20.125,22 C21.1601562,22 22,21.1601591 22,20.1601625 L22,11.8008159 L13.8320312,17.7031396 C13.2851562,18.0937633 12.640625,18.2929814 12,18.2929814 Z M21.28125,8.36723387 C20.9375,8.0937973 20.609375,7.83989192 20.125,7.47270567 L20.125,5.74927403 C20.125,4.7141213 19.2851562,3.87428041 18.25,3.87428041 L15.2226562,3.87434291 C15.1005859,3.78645258 14.9931641,3.70832785 14.8662109,3.62043752 C14.2109375,3.13795479 12.9101562,1.98548996 12,2.00013835 C11.09375,1.98548996 9.7890625,3.13795479 9.1328125,3.62115627 C9.00585938,3.7090466 8.8984375,3.78717133 8.77636719,3.87506166 L5.75,3.87506166 C4.71484375,3.87506166 3.875,4.71490255 3.875,5.75005528 L3.875,7.47348691 C3.39179687,7.83989192 3.06445312,8.0937973 2.71796875,8.36723387 C2.26367188,8.71879518 2,9.26566832 2,9.84379135 L2,10.2586337 L5.75,12.9683901 L5.75,5.75005528 L18.25,5.75005528 L18.25,12.9648745 L22,10.2551181 L22,9.84379135 C22,9.26566832 21.7382812,8.71879518 21.28125,8.36723387 Z M8.875,11.9648779 L15.125,11.9648779 C15.4701563,11.9648779 15.75,11.6850351 15.75,11.3750361 C15.75,11.0298029 15.4701563,10.7500383 15.125,10.7500383 L8.875,10.7500383 C8.52984375,10.7500383 8.25,11.0298029 8.25,11.3750361 C8.25,11.718785 8.53125,11.9648779 8.875,11.9648779 Z M8.875,9.46488639 L15.125,9.46488639 C15.4701563,9.46488639 15.75,9.18504359 15.75,8.83988852 C15.75,8.49465532 15.4701563,8.25004677 15.125,8.25004677 L8.875,8.25004677 C8.52984375,8.25004677 8.25,8.52981145 8.25,8.83988852 C8.25,9.21879348 8.53125,9.46488639 8.875,9.46488639 Z",
    id: "Shape",
    fill: "#05315F",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvitation);
export default __webpack_public_path__ + "static/media/ic_invitation.9bf4dcf448c45cd8ee146c8428043ac7.svg";
export { ForwardRef as ReactComponent };